import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Angulartics2Module } from 'angulartics2';
import { DeliveryDownloadSingleComponent } from './delivery-download-single/delivery-download-single.component';
import { DeliveryDownloadService } from './delivery-download.service';
import { MultipleFileDownloadService } from './multiple-file-download.service';

@NgModule({
  declarations: [DeliveryDownloadSingleComponent],
  imports: [CommonModule, Angulartics2Module],
  exports: [DeliveryDownloadSingleComponent],
  providers: [DeliveryDownloadService, MultipleFileDownloadService],
})
export class DeliveryDownloadModule {}
